module.exports = ".specfic{\n  height: 178px !important;\n  width: 288px !important;\n}\n\n"